import { useFetch } from "../../hooks/useFetch";
import api, { money } from "../../lib/api";
import { Loading, EmptyState } from "../../components/States";
import { CHead, CCard, Pill } from "../../components/customer/ui";
import { toast } from "sonner";
import { FileText, Check } from "lucide-react";

export default function CustomerEstimates() {
  const { data, loading, refetch } = useFetch("/estimates");
  if (loading) return <Loading />;

  const approve = async (id) => {
    try {
      await api.post(`/estimates/${id}/approve`);
      toast.success("Estimate approved! We'll schedule your work.");
      refetch();
    } catch { toast.error("Could not approve"); }
  };

  const list = data || [];
  return (
    <div className="space-y-6">
      <CHead title="Estimates" subtitle="Review your estimate and approve with one tap." />
      {list.length === 0 ? (
        <EmptyState title="No estimates yet" subtitle="After your appointment, your estimate appears here." icon={FileText} />
      ) : (
        <div className="space-y-4">
          {list.map((e) => (
            <CCard key={e.id} className="p-6" data-testid={`c-estimate-${e.id}`}>
              <div className="flex items-start justify-between">
                <div className="text-xl font-bold text-slate-900">{e.title}</div>
                <Pill status={e.status} />
              </div>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-3xl font-black text-[#1286F2]">{money(e.total)}</span>
                {e.status === 'sent' ? (
                  <button onClick={() => approve(e.id)} className="flex items-center gap-2 rounded-xl bg-emerald-500 px-6 py-3 font-bold text-white hover:bg-emerald-600" data-testid={`approve-estimate-${e.id}`}>
                    <Check size={18} /> Approve
                  </button>
                ) : (
                  <span className="flex items-center gap-2 font-semibold text-emerald-600"><Check size={18} /> Approved</span>
                )}
              </div>
            </CCard>
          ))}
        </div>
      )}
    </div>
  );
}
